<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <b-button class="btn-round"
                          :variant="(isOpenFormAddNew ? 'danger' : 'success')"
                          @click="showAndHideForm">+ Add Dictionary
                </b-button>
            </template>
        </navbar>


        <b-card v-if="isOpenFormAddNew" :title="isAddBrand ? 'Add Brand For '+dictionary.title : 'Add Dictionary'">

            <template v-if="dictionary !== null && editedDictionary === dictionary">
                <b-form-group label="title">
                    <b-input v-model="dictionary.title" placeholder=""></b-input>
                </b-form-group>
                <b-button @click="updateDictionary" variant="success">save</b-button>
            </template>

            <template v-else>
                <b-form-group label="title">
                    <b-input v-model="form.title" placeholder=""></b-input>
                </b-form-group>
                <b-button v-if="isAddBrand" @click="storeBrand" variant="success">save</b-button>
                <!--New Brand-->
                <b-button v-else @click="storeDictionary" variant="success">save</b-button>
                <!--Store Brand-->
            </template>

        </b-card>


        <b-modal size="lg" id="modal-products" title="Select Products">

            <b-row>
                <b-col cols="12" md="2">
                    <template v-if="items.categories.length > 0">
                        <b-input v-model="search.category" placeholder="search in categories"></b-input>
                        <ul class="my-list">
                            <li class="mb-3 border-bottom pb-3" v-for="(item,index) in filterCategories" :key="index">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox"
                                           :value="item.category_id"
                                           v-model="categoryIdsSelected"
                                           @change="getProducts"
                                           class="custom-control-input" :id="'category'+item.category_id">
                                    <label class="custom-control-label" :for="'category'+item.category_id">
                                        {{item.category_title}}
                                    </label>
                                </div>

                            </li>
                        </ul>
                    </template>
                </b-col>
                <b-col cols="12" md="10">
                    <b-input v-model="search.product" placeholder="search in products"></b-input>

                    <template v-if="items.products.length > 0">
                        <b-row>
                            <b-col cols="12" md="4" v-for="(product,index) in filterProducts" :key="index">
                                <b-card>
                                    <img :src="product.image" height="125" class="card-img-top">
                                    <h5 v-html="product.title"></h5>

                                    <div class="text-left mt-3 border-top pt-3">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox"
                                                   :value="product"
                                                   v-model="productsSelected"
                                                   class="custom-control-input" :id="'product'+product.id">
                                            <label class="custom-control-label" :for="'product'+product.id">
                                                select
                                            </label>
                                        </div>
                                    </div>

                                </b-card>
                            </b-col>
                        </b-row>
                    </template>
                </b-col>
            </b-row>
        </b-modal>
        <!--Modal-->


        <b-card>
            <b-row>
                <b-col cols="12" md="3">
                    <template v-if="items.dictionaries.length > 0">
                        <ul style="top: 25px" class="my-list sticky-top">
                            <draggable v-model="items.dictionaries"
                                       @update="updateOrderDictionary"
                                       group="items" @start="drag=true"
                                       handle=".handle"
                                       @end="drag=false">
                                <li v-for="(item,index) in items.dictionaries" :key="index">
                                    <a class="shadow"
                                       :class="{'active': (dictionary !== null && item.title === dictionary.title)}"
                                       @click.prevent="getDictionaryItems(item.id)"
                                       href="#">
                                        <span>{{item.title}}</span>
                                        <span class="float-right">
                                            <span class="material-icons">keyboard_arrow_right</span>
                                        </span>
                                        <span class="float-left handle mr-4">
                                            <span class="material-icons">drag_handle</span>
                                        </span>
                                    </a>
                                </li>

                            </draggable>
                        </ul>
                    </template>
                </b-col>
                <!--END Sidebar-->

                <b-col cols="12" md="9">
                    <div class="mb-4">
                        <b-row>
                            <b-col cols="6">
                                <template v-if="dictionary !== null">
                                    <div class="mt-3">
                                        <a class="text-danger mr-4"
                                           @click.prevent="deleteDictionary"
                                           href="#">delete</a>
                                        <a @click.prevent="editDictionary" class="text-info" href="#">edit</a>
                                    </div>
                                </template>
                            </b-col>
                            <b-col cols="6">
                                <div class="text-right">
                                    <b-button
                                            @click="newBrand"
                                            v-if="dictionary !== null" variant="warning">add brands
                                    </b-button>
                                    <b-button
                                            @click="storeDictionaryItems"
                                            v-if="productsSelected.length > 0" variant="success">
                                        save products
                                    </b-button>
                                </div>
                            </b-col>
                        </b-row>
                    </div>


                    <template v-if="productsSelected.length > 0">
                        <h3>your selected products for "{{editedBrand.title}}"</h3>
                        <b-card v-for="(product,index) in productsSelected"
                                :key="index"
                                class="mb-4 border-custom">
                            <div class="media">
                                <img :src="product.image" width="85" class="mr-3">
                                <div
                                        :class="{editing:editedItem === product}"
                                        class="media-body">
                                    <h5 class="mt-0 edit-content">
                                        <span>{{product.title}}</span>
                                        <span class="ml-4 text-primary">
                                                        <a @click.prevent="editItem(product)" href="#">
                                                             <span class="material-icons">edit</span>
                                                        </a>
                                                    </span>
                                    </h5>


                                    <b-input
                                            v-model="product.title"
                                            @keyup.enter="doneEdit(product)"
                                            @blur="doneEdit(product)"
                                            class="edit-form"></b-input>

                                </div>
                            </div>
                        </b-card>

                        <br>
                        <br>
                        <div style="border-bottom: 2px solid #555"></div>

                    </template>
                    <!--products selected-->


                    <template v-if="items.brands.length > 0">
                        <draggable v-model="items.brands"
                                   @update="updateOrderBrands"
                                   group="items" @start="drag=true"
                                   handle=".handle"
                                   @end="drag=false">
                            <b-card v-for="(product,index) in items.brands"
                                    :key="index"
                                    class="mb-4 border-custom">
                                <div class="media">
                                    <div
                                            :class="{editing:editedItem === product}"
                                            class="media-body">
                                        <h5 class="mt-0 edit-content">
                                            <span>{{product.title}}</span>
                                            <span class="ml-4 text-primary">
                                                        <a @click.prevent="editItem(product)" href="#">
                                                            <span class="material-icons">edit</span>
                                                        </a>
                                                            <a class="text-danger ml-3"
                                                               @click.prevent="deleteBrandItem(product.id)"
                                                               href="#">
                                                                <span class="material-icons">delete</span>
                                                            </a>
                                                <a class="ml-3" @click.prevent="showModalBox(product.id,product)"
                                                   href="#">
                                                            <span>add products</span>
                                                        </a>
                                                <a class="ml-3" @click.prevent="getBrandItems(product.id)" href="#">
                                                            <span>products</span>
                                                        </a>
                                            </span>
                                        </h5>

                                        <b-input
                                                v-model="product.title"
                                                @keyup.enter="updatebrand(product,product.title)"
                                                @blur="updatebrand(product,product.title)"
                                                class="edit-form"></b-input>
                                    </div>
                                </div>

                                <p class="text-right font-weight-bold">
                                     <span class="mr-3 handle">
                                        <span class="material-icons">drag_handle</span>
                                    </span>
                                </p>
                            </b-card>
                        </draggable>
                    </template>
                    <!--brands-->


                    <template v-if="items.dictionaryItems.length > 0">
                        <br>
                        <br>
                        <div style="border-bottom: 2px solid #555"></div>
                        <h3 class="mt-3">Saved Products For "{{brand.title}}"</h3>
                        <draggable v-model="items.dictionaryItems"
                                   @update="updateOrderDictionaryItems"
                                   group="items" @start="drag=true"
                                   handle=".handle"
                                   @end="drag=false">
                            <b-card v-for="(product,index) in items.dictionaryItems"
                                    :key="index"
                                    class="mb-4 border-custom">
                                <div class="media">
                                    <img :src="product.image" width="85" class="mr-3">
                                    <div
                                            :class="{editing:editedItem === product}"
                                            class="media-body">
                                        <h5 class="mt-0 edit-content">
                                            <span>{{product.title}}</span>
                                            <span class="ml-4 text-primary">
                                                        <a @click.prevent="editItem(product)" href="#">
                                                            <span class="material-icons">edit</span>
                                                        </a>
                                                            <a class="text-danger ml-3"
                                                               @click.prevent="deleteDictionaryItem(product.id)"
                                                               href="#">
                                                                <span class="material-icons">delete</span>
                                                            </a>
                                                    </span>
                                        </h5>

                                        <b-input
                                                v-model="product.title"
                                                @keyup.enter="updateDictionaryItem(product,product.title)"
                                                @blur="updateDictionaryItem(product,product.title)"
                                                class="edit-form"></b-input>
                                    </div>
                                </div>

                                <p class="text-right font-weight-bold">
                                     <span class="mr-3 handle">
                                        <span class="material-icons">drag_handle</span>
                                    </span>
                                </p>
                            </b-card>
                        </draggable>
                    </template>
                    <!--brand products-->
                </b-col>

            </b-row>
        </b-card>
    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notificaion from '../../Services/Notification/Nottification'
    import draggable from 'vuedraggable'

    export default {
        name: "Index",
        components: {
            Navbar,
            draggable
        },
        data() {
            return {
                isOpenFormAddNew: false,
                isAddBrand: false,
                dictionary: null,
                brand: null,
                dictionaryId: 0,
                categoryIdsSelected: [],
                productsSelected: [],
                items: {
                    categories: [],
                    dictionaries: [],
                    dictionaryItems: [],
                    brands: [],
                    products: []
                },
                form: {
                    title: null
                },
                modals: {
                    modal0: false,
                },
                search: {
                    category: null,
                    product: null,
                },
                editedItem: null,
                editedBrand: null,
                editedDictionary: null,
            }
        },
        methods: {
            newBrand() {
                this.isAddBrand = true;
                this.isOpenFormAddNew = true;
            },
            showAndHideForm() {
                this.isAddBrand = false;
                this.isOpenFormAddNew = !this.isOpenFormAddNew;
            },
            showModalBox(brandId = null, brand = null) {
                this.$root.$emit('bv::show::modal', 'modal-products', '#btnAddProducts');
                if (brandId !== null && brand !== null) {
                    this.editedBrand = brand;
                    this.getProducts(brandId);
                }
            },
            editItem(myItem) {
                this.editedItem = myItem;
            },
            editDictionary() {
                this.isOpenFormAddNew = true;
                this.editedDictionary = this.dictionary;
            },
            doneEdit(myItem) {
                if (!this.editedItem) {
                    return;
                }

                if (!myItem.title) {
                    this.$notify({
                        type: 'danger',
                        title: 'this field required !'
                    });
                    return;
                }
                this.editedItem = null;
            },
            doneEditDictionary(myItem) {
                if (!this.editedDictionary) {
                    return;
                }

                if (!myItem.title) {
                    this.$notify({
                        type: 'danger',
                        title: 'this field required !'
                    });
                    return;
                }
                this.editedDictionary = null;
                this.isOpenFormAddNew = false;
            },
            updateOrderDictionary() {
                this.$Progress.start();
                Http.post(Http.apiurl() + 'dictionary/update/order/items', {
                    items: this.items.dictionaries
                })
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.getDictionaryItems();
                            Notificaion.success(response.data.message)
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            updateOrderDictionaryItems() {
                this.$Progress.start();
                Http.post(Http.apiurl() + 'dictionary/update/order/products', {
                    items: this.items.dictionaryItems
                })
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.getDictionaryItems(this.dictionary.id);
                            Notificaion.success(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            updateOrderBrands() {
                this.$Progress.start();
                Http.post(Http.apiurl() + 'dictionary/brand/update/order/items', {
                    items: this.items.brands
                })
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.getDictionaryItems(this.dictionary.id);
                            Notificaion.success(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            storeDictionary() {

                if (this.form.title === null) {
                    Notificaion.error("please enter title");
                    return;
                }

                this.$Progress.start();
                Http.post(Http.apiurl() + 'dictionary/store', this.form)
                    .then(response => {
                        if (response.data.status_code === Http.created()) {
                            this.$Progress.finish();
                            this.form.title = null;
                            this.getDictionaries();
                            Notificaion.success(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            storeBrand() {
                this.$Progress.start();
                Http.post(Http.apiurl() + 'dictionary/brand/store', {
                    title: this.form.title,
                    dictionary_id: this.dictionaryId
                })
                    .then(response => {
                        if (response.data.status_code === Http.created()) {
                            this.$Progress.finish();
                            this.form.title = null;
                            this.getDictionaryItems(this.dictionary.id);
                            Notificaion.success(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getDictionaries() {
                this.$Progress.start();
                Http.get(Http.apiurl() + 'dictionary/index')
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.items.dictionaries = response.data.data.dictionaries;
                            this.items.categories = response.data.data.categories;
                            this.items.dictionaryItems = [];

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getDictionaryItems(id) {

                let myId;
                if (this.dictionaryId > 0 && this.dictionaryId === id) {
                    myId = this.dictionaryId;
                } else {
                    myId = id;
                }

                this.dictionaryId = id;
                this.$Progress.start();
                Http.get(Http.apiurl() + 'dictionary/show/' + myId)
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.dictionary = response.data.data.dictionary;
                            this.items.brands = response.data.data.items;
                            this.items.dictionaryItems = [];
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },

            getBrandItems(id) {
                this.$Progress.start();
                Http.get(Http.apiurl() + 'dictionary/brand/show/' + id)
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.brand = response.data.data.dictionary;
                            this.items.dictionaryItems = response.data.data.items;
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            getProducts(brandId) {
                this.$Progress.start();
                Http.post(Http.apiurl() + 'dictionary/brand/products', {
                    catIds: this.categoryIdsSelected,
                    dictionary_id: brandId
                })
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.items.products = response.data.data;
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            storeDictionaryItems() {
                this.$Progress.start();
                let items = [];
                if (this.productsSelected.length > 0) {
                    items = this.productsSelected;
                } else {
                    items = this.items.dictionaryItems;
                }
                Http.post(Http.apiurl() + 'dictionary/brand/store/products', {
                    dictionary_id: this.editedBrand.id,
                    products: items
                })
                    .then(response => {
                        if (response.data.status_code === Http.created()) {
                            this.$Progress.finish();
                            this.productsSelected = [];
                            this.getDictionaryItems(this.dictionary.id);
                            if (this.editedBrand !== null) {
                                this.getBrandItems(this.editedBrand.id);
                            }
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            updateDictionaryItem(myItem, title) {



                this.$Progress.start();
                Http.post(Http.apiurl() + 'dictionary/update/item/' + myItem.id, {
                    title: title
                })
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.form.title = null;
                            this.getDictionaryItems(myItem.id);
                            this.doneEdit(myItem);
                            Notificaion.success(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            updatebrand(myItem, title) {
                this.$Progress.start();
                Http.post(Http.apiurl() + 'dictionary/brand/update/' + myItem.id, {
                    title: title
                })
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.form.title = null;
                            this.getDictionaryItems(myItem.id);
                            this.doneEdit(myItem);
                            Notificaion.success(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            updateDictionary() {
                if (!this.dictionary.title) {
                    Notificaion.error("this field required !")
                    return;
                }

                this.$Progress.start();
                Http.post(Http.apiurl() + 'dictionary/update/' + this.dictionary.id, {
                    title: this.dictionary.title
                })
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.getDictionaries();
                            this.doneEditDictionary(this.dictionary);
                            Notificaion.success(response.data.message)
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            deleteDictionaryItem(id) {
                if (confirm("Are you sure delete this item ?")) {
                    this.$Progress.start();
                    Http.get(Http.apiurl() + 'dictionary/delete/item/' + id)
                        .then(response => {
                            if (response.data.status_code === Http.ok()) {
                                this.$Progress.finish();
                                if (this.brand !== null) {
                                    this.getBrandItems(this.brand.id);
                                }
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
            deleteBrandItem(id) {
                if (confirm("Are you sure delete this item ?")) {
                    this.$Progress.start();
                    Http.get(Http.apiurl() + 'dictionary/brand/delete/' + id)
                        .then(response => {
                            if (response.data.status_code === Http.ok()) {
                                this.$Progress.finish();
                                this.getDictionaryItems(this.dictionary.id);
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
            deleteDictionary() {
                if (confirm("Are you sure delete this item ?")) {
                    this.$Progress.start();
                    Http.get(Http.apiurl() + 'dictionary/delete/' + this.dictionary.id)
                        .then(response => {
                            if (response.data.status_code === Http.ok()) {
                                this.$Progress.finish();
                                this.dictionary = null;
                                this.items.dictionaryItems = [];
                                this.items.brands = [];
                                this.isAddBrand=false;
                                this.getDictionaries();
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
        },
        computed: {
            filterCategories() {
                if (this.search.category === null) {
                    return this.items.categories;
                }
                return this.items.categories.filter(item => {
                    return item.category_title.match(this.search.category)
                })
            },
            filterProducts() {
                if (this.search.product === null) {
                    return this.items.products;
                }

                return this.items.products.filter(item => {
                    return item.title.match(this.search.product)
                })
            },
        },
        created() {
            this.getDictionaries();
        }
    }
</script>

<style scoped>
    .my-list {
        list-style: none;
        padding-left: 0;
    }

    .my-list li {
    }

    .my-list li a {
        display: block;
        color: #000;
        font-size: 19px;
        font-weight: bolder;
        padding: 25px;
        transition: all linear 150ms;
        border: 1px solid #f1f1f1;
    }

    .my-list li:first-child a {
        border-radius: 20px 20px 0 0;
    }

    .my-list li:last-child a {
        border-radius: 0 0 20px 20px;
    }

    .my-list li a:hover {
        background-color: #f1f1f1;
    }

    .active {
        background: rgb(99, 255, 0);
        background: -moz-linear-gradient(90deg, rgba(99, 255, 0, 1) 0%, rgba(14, 177, 59, 1) 100%);
        background: -webkit-linear-gradient(90deg, rgba(99, 255, 0, 1) 0%, rgba(14, 177, 59, 1) 100%);
        background: linear-gradient(90deg, rgba(99, 255, 0, 1) 0%, rgba(14, 177, 59, 1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#63ff00", endColorstr="#0eb13b", GradientType=1);
        color: #fff !important;
    }

    .edit-form {
        display: none;
    }

    .media .editing .edit-content {
        display: none;
    }

    .media .editing .edit-form {
        display: block;
    }

    .border-custom {
        border: 1px solid #b5b5b5;
    }
</style>